import { FC, useMemo } from 'react';
import ScanSection from 'src/components/scanner/ScanSection';
import useSplitter from 'src/hooks/useSplitter';
import { InvoiceContext } from 'src/sections/invoice_details/InvoiceDetailsContext';
import OcrScanPreview from 'src/sections/invoice_details/OcrScanPreview';
import { InvoiceDetailsResponse } from 'src/services/useInvoiceDetailsApi';
import { IReceipt as ReceiptDetailsResponse } from 'src/types/Receipt';
import { useContextSelector } from 'use-context-selector';

interface ShowScansSplitterProps {
  main: JSX.Element;
  isInvoice: boolean;
  document: ReceiptDetailsResponse | InvoiceDetailsResponse;
  isLoading: boolean;
  id: string;
  companyId: string;
  getDocument: () => Promise<any>;
  showScans: boolean;
  isPoOpen: boolean;
}

const ShowScansSplitter: FC<ShowScansSplitterProps> = ({
  main,
  document,
  isLoading,
  companyId,
  getDocument,
  id,
  showScans,
  isPoOpen,
  isInvoice,
}) => {
  const title = useContextSelector(InvoiceContext, (value) => value.title);
  const initialInvoice = useContextSelector(InvoiceContext, (value) => value.initialInvoice);
  const isProcessingComplete = useContextSelector(
    InvoiceContext,
    (value) => value.invoice.isProcessingComplete
  );

  const preview = useMemo(
    () =>
      isInvoice && initialInvoice?.ocrGenerated ? (
        <OcrScanPreview document={document} isLoading={isLoading} />
      ) : (
        <ScanSection
          isInvoice={true}
          name={title}
          document={document}
          isLoading={isLoading}
          companyId={companyId}
          getDocument={getDocument}
          id={id}
          isPoOpen={isPoOpen}
          isInvoiceProcessed={isProcessingComplete}
        />
      ),
    [
      companyId,
      document,
      getDocument,
      id,
      initialInvoice?.ocrGenerated,
      isInvoice,
      isLoading,
      isPoOpen,
      isProcessingComplete,
      title,
    ]
  );
  return useSplitter(main, preview, showScans, false);
};

export default ShowScansSplitter;
